import {h, Fragment} from "preact"
import { handleSwatch } from "../helpers"
import { useState, useMemo, useEffect } from "preact/hooks"

export default function Swatches({ product, relatedProducts, storefrontData }) {
    const [isHidden, setIsHidden] = useState(true)
    const [ isExpanded, setIsExpanded ] = useState(false)

    var preSelectedProduct = relatedProducts.find(prod => prod.productId == product.productId);
    var tempIndex = relatedProducts.indexOf(preSelectedProduct);

    Array.prototype.move = function(from,to){
        this.splice(to,0,this.splice(from,1)[0]);
        return this;
    };

    relatedProducts = relatedProducts.move(tempIndex, 0);

    const swatches = relatedProducts.map((prod, index) => {
        let isCurrentProduct = false
        if(prod.productId == product.productId){
            isCurrentProduct = true
        }

        let fabric = prod.tags1?.filter(tag => tag.includes("fabric"))?.toString().split(":").pop();
        let productName = prod.tags1?.filter(tag => tag.includes("short-title"))?.toString().split(":").pop();
        let colorFamily = prod.tags1?.filter(tag => tag.includes("color:"))?.toString().split(":").pop();
        let colorFamilyClean = colorFamily?.toLowerCase().replaceAll(" ", "-")
        if(prod.name.includes("Ribbed") && !prod.name.includes("Eco Ribbed") || colorFamilyClean == "white" && prod.name.includes("Eco Ribbed")){
            colorFamilyClean = `${colorFamilyClean}-ribbed`
        }
        if(prod.name.includes("Eyelet") && fabric != "ditsy eyelet" && !colorFamilyClean.includes("-cotton-eyelet")){
            colorFamilyClean = `${colorFamilyClean}-cotton-eyelet`
        } 
        if(prod.name.includes("Gingham") && !colorFamilyClean.includes("-gingham")){
            colorFamilyClean = `${colorFamilyClean}-gingham`
        }

        let correspondingNode = storefrontData?.colorSwatches?.find(hit => hit.node.handle == colorFamilyClean);

        if(correspondingNode?.node?.fields?.find(field => field.key == "solid")){
            var hexColor = correspondingNode?.node?.fields?.find(field => field.key == "solid").value;
            return (
                <li
                    key={prod.productId}
                    className={`cursor-pointer rounded-full w-6 h-6 flex justify-center items-center ns-color ${isCurrentProduct ? 'ns-swatch-selected is-first' : ''}`}
                    index={index}
                    name={productName}
                    full-name={prod.name}
                    color-family={colorFamily}
                    onClick={(e) => handleSwatch(e, prod)}
                    style={`${isCurrentProduct ? 'order: -1' : ''}`}
                >
                    <div
                        className="w-4 h-4 rounded-full border ns-swatch"
                        data-img={prod.imageUrl}
                        data-color={colorFamily}
                        data-altImg={prod.alternateImageUrls[0]}
                        style={`background-color: ${hexColor}`}
                    ></div>
                </li>
            )
        } else if(correspondingNode?.node?.fields?.find(field => field.key == "pattern")){
            var backgroundImg = correspondingNode?.node?.fields?.find(field => field.key == "pattern")?.reference?.image?.url;
            return (
                <li
                    key={prod.productId}
                    className={`cursor-pointer rounded-full w-6 h-6 flex justify-center items-center ns-color ${isCurrentProduct ? 'ns-swatch-selected is-first' : ''}`}
                    index={index}
                    name={productName}
                    full-name={prod.name}
                    color-family={colorFamily}
                    onClick={(e) => handleSwatch(e, prod)}
                    style={`${isCurrentProduct ? 'order: -1' : ''}`}
                >
                    <div
                        className="w-4 h-4 rounded-full border ns-swatch"
                        data-img={prod.imageUrl}
                        data-color={colorFamily}
                        data-altImg={prod.alternateImageUrls[0]}
                        style={`background-image: url(${backgroundImg})`}
                    ></div>
                </li>
            )
        }
        
    })

    function toggleSwatches(e){
        // var containerWidth =  e.target.closest(".ns-colors").offsetWidth;
        // var lastInLine = parseInt(containerWidth / (24 + 8));
        // if(window.innerWidth < 1023){
        //     lastInLine = parseInt(containerWidth / (16 + 8));
        // }

        // e.target.closest(".ns-colors").querySelectorAll(".ns-swatch-hidden")?.forEach((elem) => {
        //     elem.classList.toggle("ns-d-none");
        // })
        // setIsHidden(!isHidden);

        // e.target.closest(".ns-colors").querySelector(".ns-see-more-swatches").style.order = lastInLine - 1;
    }
  
    return (
        <ul class={`ns-d-flex ns-flex-wrap ns-colors ${isExpanded ? 'expanded' : ''}`}>
            {swatches}
            {relatedProducts?.length > 4 &&
                <li class="ns-see-more-swatches w-6 h-6 flex justify-center items-center" onClick={() => setIsExpanded(!isExpanded)}>
                    <div class="w-4 h-4 rounded-full border ns-swatch ns-d-flex ns-align-items-center ns-justify-content-center" style="background-color: #F9F5EF; cursor: pointer; font-size: 16px;">
                        {isExpanded ? '-' : '+'}
                    </div>
                </li>
            }
        </ul>
    )
}